import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ProgressSpinner } from "primereact/progressspinner";

import { faCircleXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../models/app-translation-keys";
import { IProgressVisualizationProps } from "../ProgressHandler";
import { FileUploadProgressBar } from "./FileUploadProgressBar/FileUploadProgressBar";

export const ProgressBars: FunctionComponent<IProgressVisualizationProps> = (props: IProgressVisualizationProps) => {
  const { t } = useTranslation();

  return (
    <div className="progress-handler">
      <div className="progress-handler-columns">
        <FileUploadProgressBar
          columnTitleKeys={props.progressTitles}
          columnProgressValues={props.progressValues}
          showTitle={false}
          title={t(translationKeys.upload.fileUploadProgressingTitle)}
        />
      </div>

      <div className="progress-handler-spinner">
        {props.progressValues[props.progressValues.length - 1] >= 85 && (
          <ProgressSpinner className="small-inline-spinner" />
        )}
      </div>

      <div className="progress-handler-cancel-button">
        <FontAwesomeIcon icon={faCircleXmark} onClick={props.cancelProgress} />
      </div>
    </div>
  );
};
